import type { ChartConfig, ChartMentalBalance } from "@ptsd/uikit";

import type { RouterOutputs } from "~/utils/api";

type InvolvenentData = RouterOutputs["dashboard"]["getPatientActionDynamic"];

export const normalizeConfig = (data: Omit<InvolvenentData, "chartData">) => {
  return Object.keys(data.labels).reduce<ChartConfig>(
    (acc, key) => ({
      ...acc,
      [key]: {
        label: data.labels[key as keyof InvolvenentData["labels"]],
        color: data.colors[key as keyof InvolvenentData["colors"]],
      },
    }),
    {},
  );
};

type PieData = RouterOutputs["dashboard"]["getSpheresScale"]["data"];

export const normalizePieData = (
  data: PieData,
  innerCircle: ChartMentalBalance.Sector[],
) => {
  const formattedData = data.reduce<{ domain: string; score: number }[]>(
    (acc, item) => {
      const normalizedItem = item.domains.map(({ domain, score }) => {
        return {
          domain,
          score,
        };
      });

      acc.push(...normalizedItem);
      return acc;
    },
    [],
  );

  const normalizedData = innerCircle.map((item) => {
    const matchedData = formattedData.find((f) => f.domain === item.domain);
    return { ...item, value: matchedData?.score ?? 0 };
  });

  return normalizedData;
};

export type PieChartData = ReturnType<typeof normalizePieData>;
